import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchVenueSettlementCycles } from '@/lib/venue/settlementApi'
import type { SettlementCyclesFilter } from '@/lib/venue/settlementViewModel'

export function settlementCyclesQueryKey(venueId: string, filter: SettlementCyclesFilter) {
  return ['venue', venueId, 'settlements', 'cycles', filter] as const
}

/**
 * 🚨 커서가 회차월(`YYYY-MM`) 그 자체라 `lib/api/cursor.ts`의 opaque-cursor 헬퍼를 쓰지 않는다
 * (`useVenueReservations.ts`와 같은 이유 — 서버가 `nextCursor`를 이미 완성된 값으로 내려준다).
 */
export function useVenueSettlementCycles(venueId: string, filter: SettlementCyclesFilter) {
  return useInfiniteQuery({
    queryKey: settlementCyclesQueryKey(venueId, filter),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchVenueSettlementCycles(venueId, filter, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
  })
}
